var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_25_x25_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_50_x25_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_75_x25_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Download_x5F_100_x25_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Upload"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Next"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Last"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "OK"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Fail"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_0_x25_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_25_x25_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_50_x25_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Spinner_x5F_75_x25_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_25_x25_"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_50_x25_"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_75_x25_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Brightest_x5F_100_x25_"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Reload"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Forbidden"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Clock"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Compass"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "World"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Speed"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Microphone"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Options"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Chronometer"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Lock"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "User"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Position"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Options_1_"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Flash"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "No_x5F_Signal_x5F_02"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Low_x5F_Signal_x5F_02"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Mid_x5F_Signal_x5F_02"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "High_x5F_Signal_x5F_02"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Favorite"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_01"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Stats_x5F_02"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Turn_x5F_On_x5F_Off"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Height"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Width"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Full_x5F_Screen"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Compress_x5F_Screen"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Chat"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Bluetooth"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_iOS"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Share_x5F_Android"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Love__x2F__Favorite"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Hamburguer"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M33.791,33.604c4.528-4.528,10.462-6.791,16.396-6.791c5.934,0,11.868,2.264,16.396,6.791c4.527,4.527,6.79,10.459,6.791,16.392 c0.001,5.936-2.263,11.872-6.791,16.4c-9.055,9.055-23.737,9.055-32.792,0S24.736,42.659,33.791,33.604z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.187,
    y1: 50,
    x2: 42.187,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.187,
    y1: 42,
    x2: 42.187,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 58.187,
    y1: 58,
    x2: 42.187,
    y2: 58
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Flying"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Take_x5F_Off"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Land"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "City"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Nature"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Pointer"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Prize"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Extract"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Play"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Pause"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Stop"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Forward"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Reverse"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Next_1_"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Last_1_"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Empty_x5F_Basket"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Add_x5F_Basket"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Delete_x5F_Basket"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Error_x5F_Basket"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "OK_x5F_Basket"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.3bfd5130df495851af3f22e7b89a698f.svg";
export { ForwardRef as ReactComponent };